import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { delQueStr } from '@tencent/vft-common/util';
import pop from '@/mixin/pop';
import config from '@/config';
export default {
  mixins: [pop],
  data: function data() {
    return {
      starid: config.starid
    };
  },
  computed: {
    curStarIndex: function curStarIndex() {
      var _this = this;

      return this.starList.findIndex(function (star) {
        return star.id === _this.starid;
      });
    },
    curStar: function curStar() {
      return this.starList[this.curStarIndex];
    }
  },
  methods: {
    launchPowerPop: function launchPowerPop() {
      if (!this.myPropsNum) {
        this.eventBus.$emit('showPayPop', {
          id: this.starid
        });
      } else {
        this.eventBus.$emit('showPowerPop', {
          id: this.starid
        });
      }

      this.close();
    },
    clearKey: function clearKey() {
      var _window = window,
          location = _window.location,
          history = _window.history;

      try {
        var url = location.href;
        var keys = ['starid'];
        keys.forEach(function (key) {
          url = delQueStr(url, key);
        });

        if (history.replaceState) {
          history.replaceState(null, document.title, url);
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  mounted: function mounted() {
    if (config.starid) {
      this.clearKey();
    }
  }
};